<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Historial de Nomina

            <!-- <router-link
                        :to="{
                          name: 'NuevoCalculoAdministrativo',
                          params: {
                            config: { page: page, dates: query.periodo }
                          }
                        }"
                      >
                        <CButton color="primary" class="mr-1 btn-header">
                          <CIcon class="mr-1" name="cil-pencil" />Registrar Cálculo administrativo
                        </CButton>
                      </router-link> -->

            <CRow style="gap: 10px" class="justify-content-right">
              <template
                v-if="
                  hasTheCredential(
                    '@view:schema=cuadre_fiscal\\|.*calcular_cuadre'
                  )
                "
              >
                <CButton
                  color="primary"
                  class="btn-header"
                  @click="handleEncuadre()"
                >
                  <CIcon class="mr-1" name="cil-pencil" />
                  Calcular Ajuste Fiscal
                </CButton>
              </template>

              <template
                v-if="
                  hasTheCredential(
                    '@view:schema=cuadre_fiscal\\|.*calcular_cuadre'
                  )
                "
              >
                <CButton color="primary" class="btn-header">
                  <router-link
                    tag="span"
                    :to="{
                      name: 'BitacoraNomina',
                      params: { config: { page: page } },
                    }"
                  >
                    <CIcon class="mr-1" name="cil-pencil" />
                    Bitácora de Ajuste Fiscal
                  </router-link>
                </CButton>
              </template>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="6" lg="6" xl="4">
                <label class="d-block">Periodo:</label>
                <DateSelector
                  class="z-custom-2 mb-2"
                  v-model="query.periodo"
                  :date="query.periodo"
                  :is-valid="checkIfValid('periodo')"
                />
              </CCol>
            </CRow>

            <CRow class="">
              <CCol sm="11" col="10">
                <CRow class="advance-filter mb-4">
                  <CCol md="6" class="py-1">
                    <label class="d-block">Empresa:</label>

                    <vSelectC
                      class="margin-multi"
                      :class="
                        checkIfValid('empresa') === false ? 'is-invalid' : ''
                      "
                      v-model="query.empresa"
                      :options="empresas"
                      :loading="isLoadingInfo"
                      placeholder="Empresa"
                      @input="getTrabajadores"
                    >
                      <template #open-indicator="{ attributes }">
                        <CIcon
                          v-bind="attributes"
                          class="cursor-p"
                          name="cil-caret-bottom"
                        />
                      </template>
                      <template #no-options>Sin resultados.</template>
                    </vSelectC>
                  </CCol>

                  <CCol md="6" class="py-1">
                    <label class="d-block">Trabajador:</label>

                    <vSelectC
                      class="margin-multi"
                      :class="
                        checkIfValid('trabajador') === false ? 'is-invalid' : ''
                      "
                      v-model="query.trabajador"
                      :options="trabajadores"
                      :loading="isLoadingInfo"
                      placeholder="Trabajador"
                    >
                      <template #open-indicator="{ attributes }">
                        <CIcon
                          v-bind="attributes"
                          class="cursor-p"
                          name="cil-caret-bottom"
                        />
                      </template>
                      <template #no-options>Sin resultados.</template>
                    </vSelectC>
                  </CCol>

                  <CCol col="10" class="pt-3">
                    <CButton @click="validForm" color="primary">
                      Buscar</CButton
                    >
                  </CCol>
                </CRow>
              </CCol>

              <div
                v-if="laboresIsSelected"
                class="ml-2 d-flex flex-column justify-content-end align-items-end w-100"
              >
                <div class="d-flex justify-content-end align-items-center">
                  <CButton
                    @click="show = true"
                    color="danger"
                    class="mr-1 sp-width-butom d-flex align-items-center"
                  >
                    <CIcon class="mr-1" name="cil-list" />Cancelar Cálculos
                    administrativos
                  </CButton>
                </div>
                <label class="d-block text-right mt-2 mb-0"
                  >{{ _countSelected_ }} elementos selecciónados</label
                >
              </div>
            </CRow>

            <GrandTable
              :loading="isLoading"
              :columns="columns"
              :data="items"
              @sort="({ field, order, join }) => sortField(field, order, join)"
            >
              <template
                v-for="head of customHeaders"
                #[`${head.field}-header`]="{ title, data }"
              >
                {{
                  data.length
                    ? formaters(head.tituloFormato.tipo, head.default)(
                        getDotNotation(title, data[0]),
                        head.tituloFormato
                      )
                    : ""
                }}
              </template>
              <template #trabajador_id="{ row, className }">
                <td :class="className">
                  {{
                    row.payload.encabezado._relaciones.trabajador.payload.nombre
                  }}
                </td>
              </template>

              <template #custom="{ row, className }">
                <td :class="className">
                  {{ row.payload.encabezado }}
                </td>
              </template>

              <template
                v-for="colum of customColumns"
                #[`${colum.field}`]="{ row, className, colStyle }"
              >
                <td :key="colum.field" :class="className" :style="colStyle">
                  {{
                    formaters(colum.formato.tipo)(
                      getDotNotation(colum.field, row),
                      colum.formato
                    )
                  }}
                </td>
              </template>

              <template #total="{ row, className, colStyle }">
                <td
                  :class="className"
                  style="font-weight: bold"
                  :style="colStyle"
                >
                  {{
                    $formatter(
                      row.payload.encabezado.totales.sueldo_neto
                        ? row.payload.encabezado.totales.sueldo_neto
                        : 0,
                      1
                    )
                  }}
                </td>
              </template>

              <template #ver="{ row, className, colStyle }">
                <td
                  :class="className"
                  style="font-weight: bold"
                  :style="colStyle"
                >
                  <router-link
                    :to="{
                      name: row.folio
                        ? 'VerCalculoAdministrativoNominaFolio'
                        : 'VerCalculoAdministrativoNomina',
                      params: {
                        ...(row.folio
                          ? { id: row.folio }
                          : {
                              periodo_inicial:
                                row.payload.encabezado.periodo_inicial,
                              periodo_final:
                                row.payload.encabezado.periodo_final,
                              empresa_id: row.payload.encabezado.empresa_id,
                              trabajador_id:
                                row.payload.encabezado.trabajador_id,
                            }),
                        config: { page: page, dates: query.periodo },
                      },
                    }"
                  >
                    <CButton color="success" square size="sm">Ver</CButton>
                  </router-link>
                </td>
              </template>
              <template #under-table>
                <div class="footer-table">
                  <div
                    style="gap: 5px"
                    class="d-flex align-items-center justify-content-start"
                  >
                    Total {{ total }} ,
                    <CSelect
                      :value="limit"
                      label=""
                      invalidFeedback="Campo requerido, debe seleccionar una opción"
                      :options="[10, 25, 50, 100]"
                      @update:value="(v) => (limit = v)"
                      class="mb-0"
                    />{{ " " }}artículos / página
                  </div>
                  <CPagination
                    :activePage.sync="page"
                    :pages="pages"
                    align="center"
                    @update:activePage="(e) => actualizarInfo()"
                  />
                </div>
              </template>
            </GrandTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      size="sm"
      title=""
      :centered="true"
      :no-close-on-backdrop="true"
      color="danger"
      :show.sync="show"
    >
      <template #header>
        <h5 class="modal-title">Cancelar cálculos administrativos</h5>
        <CButtonClose @click="show = false" class="text-white" />
      </template>
      ¿Esta seguro que quiere cancelarlos?
      <template #footer>
        <CButton @click="show = false" color="danger"> Cancelar</CButton>
        <CButton @click="cancelarDocs()" color="success">Aceptar</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="showEncuadre"
      :no-close-on-backdrop="true"
      :centered="false"
      title="Calcular Ajuste Fiscal"
      color="info"
    >
      <CRow>
        <CCol sm="12" md="9" lg="9">
          <label class="d-block">Periodo:</label>
          <DateSelector
            :disabled="isLoading"
            class=""
            v-model="fechaCalcularPagoDias"
            :date="fechaCalcularPagoDias"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" md="9" lg="9">
          <label>Trabajador:</label>
          <vSelectC
            :disabled="isLoading"
            v-model="encuadre.trabajador"
            :options="trabajadoresCalculo"
            class="margin-multi"
            :loading="isLoadingInfo"
            placeholder="Selecciona una trabajador"
          >
            <template #open-indicator="{ attributes }">
              <CIcon
                v-bind="attributes"
                style="cursor: pointer"
                name="cil-caret-bottom"
              />
            </template>
          </vSelectC>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" md="9" lg="9">
          <label>Empresa:</label>
          <vSelectC
            :disabled="isLoading"
            v-model="encuadre.empresa"
            :options="empresas"
            class="margin-multi"
            :loading="isLoadingInfo"
            placeholder="Selecciona una empresa"
          >
            <template #open-indicator="{ attributes }">
              <CIcon
                v-bind="attributes"
                style="cursor: pointer"
                name="cil-caret-bottom"
              />
            </template>
          </vSelectC>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="9" md="9" lg="9">
          <CAlert fade color="danger" class="mb-1 mt-4" :show.sync="alertError"
            >{{ message }}
          </CAlert>
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Calcular Ajuste Fiscal</h5>
        <div class="text-white close pointer" @click="showInfo = true">
          <i class="fa fa-question-circle-o" />
        </div>
        <CButtonClose
          @click="showEncuadre = false"
          class="text-white"
          style="margin-left: 0"
        />
      </template>
      <template #footer>
        <CButton
          :disabled="isLoading"
          @click="showEncuadre = false"
          color="danger"
        >
          Cancelar
        </CButton>
        <CButton
          @click="(_) => calcularCuadre()"
          color="success"
          :disabled="isLoading"
          >Aceptar</CButton
        >
      </template>
    </CModal>
    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Cancelar"
      color="danger"
    >
      <h5 class="text-center">
        ¿Deseas cancelar el bono con folio {{ this.itemModal.name }}?
      </h5>
      <template #header>
        <h5 class="modal-title">Cancelar Cálculo administrativo</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>

      <template #footer>
        <CButton @click="cancelModal = false" color="danger"> Cancelar</CButton>
        <CButton
          @click="cancelDocto(itemModal.index, itemModal.id)"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Reporte"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
      >{{ error }}</CModal
    >
    <CModal
      :closeOnBackdrop="false"
      size="sm"
      :title="loadingModal || ''"
      :centered="true"
      color="info"
      :show.sync="_loadingModal"
    >
      <template #footer>
        <strong></strong>
      </template>
      <div class="w-100 d-flex justify-content-center">
        <div class="sk-flow align-items-center">
          <div class="sk-flow-dot bg-primary"></div>
          <div class="sk-flow-dot bg-primary"></div>
          <div class="sk-flow-dot bg-primary"></div>
        </div>
      </div>
    </CModal>

    <ModalTable
      title="Calculo Ajuste Fiscal"
      :datasheet="pagosDias"
      :show="showTablePagosDias"
      :showCalculosAdministrativos="true"
    />
  </div>
</template>

<script>
import GrandTable from "./GrandTable.vue";

import moment from "moment";
import DateSelector from "../../../customComponents/DateSelector";
import ModalTable from "@/customComponents/ModalTable";

import GridAutorMixin from "../../../mixins/GridAutor";
import DotNotationMixin from "../../../mixins/DotNotationMixin";
import CredentialMixin from "@/mixins/CredentialMixin";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import "vue-select/dist/vue-select.css";

import FilterTh from "../Depuraciones/utils/th-Filter";
import EmptyTh from "../Depuraciones/utils/th-Empty";
// import mockData from "../Depuraciones/utils/filter";

export default {
  name: "CalculoAdministrativoNomina",

  components: {
    // "v-date-picker": DatePicker,
    DateSelector,

    // eslint-disable-next-line vue/no-unused-components
    FilterTh,
    // eslint-disable-next-line vue/no-unused-components
    EmptyTh,

    GrandTable,
    ModalTable,
  },
  mixins: [GridAutorMixin, validationMixin, DotNotationMixin, CredentialMixin],
  validations: {
    query: {
      empresa: {
        required,
      },
      trabajador: {},
      periodo: {
        required,

        isWithinWeekRange: (v) => {
          if (!v.start || !v.end) {
            return true;
          }
          const week = moment(v.end).diff(moment(v.start), "days");
          return week === 6;
        },
        isBeginningWeek: function (v) {
          if (!v.start) {
            return true;
          }
          return moment(v.start).day() === this.inicio_semana;
        },
      },
    },
  },
  data() {
    return {
      limit: 10,
      total: 0,
      laboresCheck: {},
      items: [],
      encabezados: [],
      labores: [],
      loadingModal: "",
      query: {
        periodo: {
          start: moment().startOf("month").toDate(),
          end: moment().endOf("month").toDate(),
        },
        empresa: null,
        trabajador: null,
      },
      encuadre: {
        trabajador: null,
        empresa: null,
      },
      inicio_semana: -1,
      config: this.$route.params.config,
      dropdownCustom: false,
      show: false,
      showCancel: false,
      isLoteActive: true,

      color1: "primary",
      color2: "secondary",
      filter: "",
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },

      tiposCosto: [
        { value: "cosecha", label: "Cosecha" },
        { value: "no_cosecha", label: "No cosecha" },
      ],
      actualSort: "doc_calculos_administrativos.payload->encabezado->fechahora",
      actualSortJoin: "",
      trabajadoresCalculo: [],
      trabajadores: [],
      trabajadoresAll: [],
      empresas: [],

      showHora: false,
      showCratedAt: false,
      itemModal: { id: "", name: "", index: "" },
      cancelModal: false,
      isLoading: false,
      isLoadingInfo: false,
      page: 1,
      pages: 1,
      warningModal: false,
      error: "",
      sorting: "desc",
      sortingJoin: "",
      sort: [
        {
          field: "folio",
          isSorter: true,
        },
        {
          field: "doc_calculos_administrativos.payload->encabezado->fechahora",
          isSorter: true,
        },
      ],

      loader: {},

      showEncuadre: false,
      alertError: false,
      message: "",
      fechaCalcularPagoDias: {
        start: moment().startOf("month").toDate(),

        end: moment().endOf("month").toDate(),
      },
      showTablePagosDias: false,
      isCreated: false,
      timer: null,
      pagosDias: [],
    };
  },

  async created() {
    this.bootstrapInfo();
  },

  computed: {
    ubicaciones() {
      return this.$store.state.rootLocations?.map((m) => m.value);
    },
    inicio_semana_() {
      return [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ][this.inicio_semana];
    },
    customColumns() {
      return this.items.length > 0
        ? this.encabezados.map((m) => {
            return {
              ...m,
              title: m.titulo,
              field: m.valor,
              sort: m.valor.replace(/\./g, "->"),
              colStyle: {
                ...(["moneda", "number", "numero", "price"].includes(
                  m.formato.tipo
                )
                  ? { "text-align": "right" }
                  : {}),
              },

              sortable: false,
            };
          })
        : [];
    },
    columns() {
      return [
        {
          title: "#",
          field: "folio",
          sticky: true,
          colStyle: {
            width: "10px",
          },

          sortable: false,
          filterable: false,
        },
        {
          title: "Trabajador",
          field: "trabajador_id",
          join: "trabajador.payload->nombre",
          sticky: true,
          colStyle: {},

          sortable: false,
          filterable: false,
          lists: "trabajadores",
        },
        // {
        //     title: "CUSTOM",
        //     field: "custom",
        //     colStyle: {
        //         width: "125px"
        //     },

        // },

        ...this.customColumns,

        {
          title: "Total",
          field: "total",
          sort: "payload->encabezado->totales->sueldo_neto",
          stickyRight: true,
          colStyle: {
            width: "40px",
            "text-align": "right",
          },

          sortable: false,
          filterable: false,
        },
        {
          title: "",
          field: "ver",

          stickyRight: true,
          colStyle: {
            width: "40px",
            "text-align": "right",
          },
        },
      ];
    },
    customHeaders() {
      return this.customColumns.filter((f) => f.headerVariable);
    },
    _loadingModal: {
      get() {
        return !!this.loadingModal;
      },
      set(val) {
        this.loadingModal = val || "";
      },
    },
    _countSelected_() {
      return Object.keys(this.laboresCheck).reduce(
        (v, key) => (this.laboresCheck[key] ? v + 1 : v),
        0
      );
    },

    docsLaboresCancel_() {
      return this.laboresCheck_.map((m) => ({
        folio: m,
        serie: "",
        schema: "calculos_administrativos",
      }));
    },
    laboresIsSelected() {
      return Object.keys(this.laboresCheck).some((s) => this.laboresCheck[s]);
    },
    laboresCheck_() {
      return Object.keys(this.laboresCheck).filter(
        (ff) => this.laboresCheck[ff]
      );
    },
    rangeStart() {
      return new Date(this.query.periodo.start).toLocaleDateString();
    },
    rangeEnd() {
      return new Date(this.query.periodo.end).toLocaleDateString();
    },
    filteredItems() {
      return this.items.filter(
        (i) =>
          i.folio
            .toString()
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          this.getDate(i.payload.encabezado.fechahora)
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          this.getTrabajador(i.payload.encabezado.trabajador_id)
            .toLowerCase()
            .includes(this.filter.toLowerCase())
      );
    },
    headersTable() {
      return this.fields.filter((ff) => {
        if (
          (ff.key === "hour" && !this.showHora) ||
          (ff.key === "created_at" && !this.showCratedAt) ||
          (ff.key === "autor" && !this.mostrarColumnaAutor)
        ) {
          return false;
        }
        return true;
      });
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
  },

  watch: {
    limit() {
      this.page = 1;
      this.actualizarInfo();
    },
    items(newV) {
      this.loader = newV.reduce((v, c, i) => ({ ...v, [i]: false }), {});
      Object.keys(this.laboresCheck).forEach((key) => {
        if (!newV.find((f) => f.folio === Number(key))) {
          delete this.laboresCheck[key];
        }
      });
    },
    ubicacionRaiz: async function () {
      if (this.ubicacionRaiz == "") {
        this.items = [];
        return;
      }
      this.page = 1;
      await this.bootstrapInfo();
      // this.actualizarInfo();
    },
  },

  methods: {
    calcularCuadre() {
      this.isLoading = true;
      const payloadCuadre = {
        fecha_inicial: moment(this.fechaCalcularPagoDias.start).format(
          "YYYY-MM-DD"
        ),
        fecha_final: moment(this.fechaCalcularPagoDias.end).format(
          "YYYY-MM-DD"
        ),
        trabajador_id:
          this.encuadre.trabajador === null ||
          this.encuadre.trabajador.value === undefined
            ? 0
            : this.encuadre.trabajador.value,
        empresa_id:
          this.encuadre.empresa === null ||
          this.encuadre.empresa.value === undefined
            ? 0
            : this.encuadre.empresa.value,
      };
      console.log(payloadCuadre);
      debugger;
      this.$store
        .dispatch("httpAny", {
          endpoint: "ajuste_fiscal:calcular_ajuste_fiscal",
          body: payloadCuadre,
        })
        .then((response) => {
          this.isLoading = false;
          this.encuadre.trabajador = 0;
          this.encuadre.empresa = 0;
          this.pagosDias = response.data.map((trabajador) => {
            delete trabajador["trabajador_id"];
            return trabajador;
          });
          this.showEncuadre = false;
          this.showTablePagosDias = true;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          this.alertError = true;
          this.message = error.message;
          setTimeout(() => {
            this.alertError = false;
            return;
          }, 2000);

          // display error
        });
    },
    dateSelection() {
      if (this.advanceFilter) {
        return;
      }
      if (this.isCreated) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          this.actualizarInfo();
        }, 800);
      }
    },
    searchTimeOut() {
      if (this.isCreated) {
        this.showTablePagosDias = false;
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          this.actualizarInfo();
        }, 800);
      }
    },
    toggleCancel(index, item) {
      this.showTablePagosDias = false;
      this.cancelModal = true;
      const itemIndex = {
        id: item.folio,
        name: item.folio,
        index: index,
      };
      this.itemModal = itemIndex;
      console.log(this.showTablePagosDias);
    },
    handleEncuadre() {
      this.showTablePagosDias = false;
      this.showEncuadre = true;
    },
    getTrabajadores(value) {
      this.query.trabajador = null;
      if (!value) {
        this.trabajadores = [];
        this.trabajadoresAll = [];
        return;
      }
      this.isLoadingInfo = true;

      this.$store
        .dispatch("customHTTP", {
          schema: "trabajadores",
          filter: {
            where: [
              {
                field: "payload->empresa_id",
                operator: "=",
                value: value.value,
              },
              {
                field: "payload->ubicaciones",
                operator: "regexp",
                value: `[[:<:]](${this.ubicaciones.join("|")})[[:>:]]`,
              },
              {
                field: "payload->suspendido",
                operator: "=",
                value: false,
              },
            ],
          },
        })
        .then((trabajadores) => {
          this.trabajadoresAll = trabajadores.data.sort((a, b) =>
            a.payload.nombre.localeCompare(b.payload.nombre)
          );
          this.trabajadores = trabajadores.data
            .map((trabajador) => {
              return {
                value: trabajador.id,
                label: [trabajador.payload.nombre].join(" "),
              };
            })
            .sort((a, b) => a.label.localeCompare(b.label));
        })
        .finally(() => {
          this.isLoadingInfo = false;
        });
    },
    checkIfValid(fieldName) {
      const field = this.$v.query[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    async bootstrapInfo() {
      this.page = this.config ? this.config.page : 1;
      // console.log(this.page);
      this.query.periodo = this.config ? this.config.dates : this.query.periodo;

      await Promise.all([
        this.$store.dispatch("customHTTP", {
          schema: "configuracion",
          filter: {
            where: [
              {
                field: "payload->parametro",
                operator: "=",
                value: "analisis_nomina",
              },
            ],
          },
        }),
        this.$store.dispatch("customHTTP", {
          schema: "empresas",
        }),
        this.$store.dispatch("customHTTP", {
          schema: "configuracion",
          filter: {
            where: [
              {
                field: "payload->parametro",
                operator: "=",
                value: "primer_dia_semana",
              },
            ],
          },
        }),
        this.$store.dispatch("customHTTP", {
          schema: "trabajadores",
          filter: {
            where: [
              {
                field: "payload->ubicaciones",
                operator: "regexp",
                value: `[[:<:]](${
                  this.ubicacionRaiz || this.ubicaciones.join("|")
                })[[:>:]]`,
              },
              {
                field: "payload->suspendido",
                operator: "=",
                value: false,
              },
            ],
          },
        }),
      ])
        .then(([config, empresas, configuraciones, trabajadores]) => {
          if (config.data.length > 0) {
            this.encabezados =
              config.data[0].payload.valor.modulo_general.encabezados;
          }

          if (empresas && empresas.data.length > 0) {
            this.empresas = empresas.data
              .map((empresa) => {
                return {
                  value: empresa.id,
                  label: empresa.payload.nombre,
                };
              })
              .sort((a, b) => a.label.localeCompare(b.label));
          }
          if (configuraciones.data.length) {
            this.inicio_semana = configuraciones.data[0].payload.valor;
          }
          if (trabajadores && trabajadores.data.length > 0) {
            this.trabajadoresCalculo = trabajadores.data
              .map((trabajador) => {
                return {
                  value: trabajador.id,
                  label: trabajador.payload.nombre,
                };
              })
              .sort((a, b) => a.label.localeCompare(b.label));
          }
          // this.encabezados = {
          //   valor: {
          //     modulo_general: {
          //       encabezados: [
          //         {
          //           headerVariable: true,
          //           titulo: "payload.encabezado.dias.0.fecha",
          //           valor: "payload.encabezado.dias.0.totales.total",
          //           formato: { tipo: "moneda" },
          //           tituloFormato: { tipo: "fecha", formato: "DD/MM/YYYY" }
          //         },
          //         {
          //           headerVariable: true,
          //           titulo: "payload.encabezado.dias.1.fecha",
          //           valor: "payload.encabezado.dias.1.totales.total",
          //           formato: { tipo: "moneda" },
          //           tituloFormato: { tipo: "fecha", formato: "DD/MM/YYYY" }
          //         },
          //         {
          //           headerVariable: true,
          //           titulo: "payload.encabezado.dias.2.fecha",
          //           valor: "payload.encabezado.dias.2.totales.total",
          //           formato: { tipo: "moneda" },
          //           tituloFormato: { tipo: "fecha", formato: "DD/MM/YYYY" }
          //         },
          //         {
          //           headerVariable: true,
          //           titulo: "payload.encabezado.dias.3.fecha",
          //           valor: "payload.encabezado.dias.3.totales.total",
          //           formato: { tipo: "moneda" },
          //           tituloFormato: { tipo: "fecha", formato: "DD/MM/YYYY" }
          //         },
          //         {
          //           headerVariable: true,
          //           titulo: "payload.encabezado.dias.4.fecha",
          //           valor: "payload.encabezado.dias.4.totales.total",
          //           formato: { tipo: "moneda" },
          //           tituloFormato: { tipo: "fecha", formato: "DD/MM/YYYY" }
          //         },
          //         {
          //           headerVariable: true,
          //           titulo: "payload.encabezado.dias.5.fecha",
          //           valor: "payload.encabezado.dias.5.totales.total",
          //           formato: { tipo: "moneda" },
          //           tituloFormato: { tipo: "fecha", formato: "DD/MM/YYYY" }
          //         },
          //         {
          //           headerVariable: true,
          //           titulo: "payload.encabezado.dias.6.fecha",
          //           valor: "payload.encabezado.dias.6.totales.total",
          //           formato: { tipo: "moneda" },
          //           tituloFormato: { tipo: "fecha", formato: "DD/MM/YYYY" }
          //         }
          //       ]
          //     }
          //   },
          //   parametro: "analisis_nomina"
          // }.valor.modulo_general.encabezados;
        })
        .finally(() => {
          this.isCreated = true;
        });

      // this.actualizarInfo(true);
    },

    validForm() {
      this.$v.$reset();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.actualizarInfo();
      }
    },
    cancelarDocs() {
      this.show = false;
      this.isLoading = true;
      this.isLoading = false;

      this.loadingModal = "Cancelando...";
      this.$store
        .dispatch("customDocumentoCancelHTTP", this.docsLaboresCancel_)
        .then(() => {
          this.actualizarInfo();
        })
        .catch((rej) => {
          console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
          this.isLoading = false;
          return;
        })

        .finally(() => {
          this.editModal = false;
          this.edit = {};
          this.isLoading = false;
          this.loadingModal = "";
          this.laboresCheck = {};
        });
    },
    checkAll(e) {
      this.laboresCheck = this.items.reduce((v, c) => {
        v[c.folio] = e.target.checked;
        return v;
      }, {});
    },
    getReporte(index, item) {
      if (this.loader[index]) {
        return;
      }
      this.loader[index] = true;
      this.$forceUpdate();
      const reportCall = {
        reporte: "formato_calculos_administrativos",
        params: { folio: item.folio, ubicaciones: [this.ubicacionRaiz] },
        pdf: true,
      };

      // console.log(reportCall);
      // call.push(reportCall);

      this.$store
        .dispatch("reportsPDFHttp", {
          ...reportCall,
        })
        .then((res) => {
          const blob = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Reporte de calculos_administrativos.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((rej) => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.loader[index] = false;
          this.$forceUpdate();
        });
    },
    closeDropdown() {
      this.dropdownCustom = false;
    },

    sortField(field, direction, join) {
      if (join) {
        this.actualSort = "";
        this.sorting = "";
        this.actualSortJoin = field;
        this.sortingJoin = direction;
      } else {
        this.actualSort = field;
        this.sorting = direction;
        this.actualSortJoin = "";
        this.sortingJoin = "";
      }
      this.actualizarInfo();
    },
    getSorted(field) {
      const newSort = this.sort.find((item) => item.field == field);
      if (newSort) {
        return newSort.isSorter;
      }
      return false;
    },
    getTrabajador(trabajador_id) {
      const trabajadorActual = this.trabajadores.filter(
        (trabajador) => trabajador.id == trabajador_id
      );
      if (trabajadorActual.length > 0) {
        return trabajadorActual[0].payload.nombre;
      } else {
        return "";
      }
    },
    getEmpresas(empresa_id) {
      const empresaActual = this.empresas.filter(
        (empresa) => empresa.id == empresa_id
      );
      if (empresaActual.length > 0) {
        return empresaActual[0].payload.nombre;
      } else {
        return "";
      }
    },
    getFullDate(date) {
      if (date === undefined || date === "") {
        return "N/A";
      }
      let newDate = moment(date, "YYYY-MM-DD HH:mm:ss");
      return newDate.format("DD/MM/YYYY HH:mm:ss");
    },
    getDate(date) {
      if (date === undefined || date === "") {
        return "N/A";
      }
      let newDate = moment(date, "YYYY-MM-DD 00:00:00");
      return newDate.format("DD/MM/YYYY");
    },
    getHour(date) {
      if (date === undefined || date === "") {
        return "N/A";
      }
      let newDate = moment(date, "YYYY-MM-DD HH:mm:ss");
      return newDate.format("HH:mm:ss");
    },
    toggleEdit(index, item) {
      this.modal = true;
      const itemIndex = {
        id: index,
        name: item.cultivo,
      };
      this.itemModal = itemIndex;
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.folio,
        name: item.folio,
        index: index,
      };
      this.itemModal = itemIndex;
    },
    filterLotes() {
      // let compareLote = this.lotes.find(lote => lote.value == this.lote);
      return this.items.filter(
        (doc) =>
          new Date(doc.payload.encabezado.fechahora) >=
            this.query.periodo.start &&
          new Date(doc.payload.encabezado.fechahora) <= this.query.periodo.end
      );
    },

    cancelDocto(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customDocumentoCancelHTTP", {
          schema: "calculos_administrativos",
          folio: id,
        })
        .then(() => {
          // console.log(res.data);
          // const index = this.items.findIndex(item => item.folio == id);
          // // console.log(this.items[index]);

          // this.items[index].estado = "cancelado";
          this.actualizarInfo();

          // this.updateData();
        })
        .catch((rej) => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;

          // if (index !== -1) {
          //   this.items.splice(index, 1);
          // }
          this.cancelModal = false;
        });
    },
    actualizarInfo() {
      this.$v.$reset();

      this.isLoading = true;
      let template = {
        schema: "calculos_administrativos",
        // limit: this.limit,
        // page: this.page,
        filter: {
          wherein: [
            {
              field:
                "doc_calculos_administrativos.payload->encabezado->ubicacion_raiz_id",
              value: this.ubicaciones,
            },
          ],
          where: [
            {
              field: "doc_calculos_administrativos.estado",
              operator: "!=",
              value: "cancelado",
            },
            {
              field:
                "doc_calculos_administrativos.payload->encabezado->empresa_id",
              operator: "=",
              value: this.query.empresa.value,
            },
            {
              field:
                "doc_calculos_administrativos.payload->encabezado->periodo_inicial",
              operator: ">=",
              value: moment(this.query.periodo.start).format("YYYY-MM-DD"),
            },
            {
              field:
                "doc_calculos_administrativos.payload->encabezado->periodo_final",
              operator: "<=",
              value: moment(this.query.periodo.end).format("YYYY-MM-DD"),
            },
          ],
        },
        ["with-storage"]: ["*"],
      };
      if (this.query.trabajador) {
        template.filter.where.push({
          field:
            "doc_calculos_administrativos.payload->encabezado->trabajador_id",
          operator: "=",
          value: this.query.trabajador.value,
        });
      }

      this.$store
        .dispatch("customDocumentoHTTP", template)
        .then(async (documentos) => {
          const trabajadoresList = this.query?.trabajador?.value
            ? this.trabajadoresAll.filter(
                (f) => f.id === this.query.trabajador.value
              )
            : this.trabajadoresAll;

          this.total = trabajadoresList.length || 0;
          // this.page = documentos?.paginate?.current_page;
          this.pages = Math.ceil(trabajadoresList.length / this.limit);
          const trabajadoresSlice = trabajadoresList.slice(
            (this.page - 1) * this.limit,
            this.page * this.limit
          );
          const trabajadores_ids = trabajadoresSlice.filter(
            (trabajador) =>
              !documentos.data
                .map((m) => m.payload.encabezado.trabajador_id)
                .includes(trabajador.id)
          );
          console.log(trabajadores_ids);
          debugger;

          const calculos = trabajadores_ids.map((m) => {
            const itm = {
              payload: {
                encabezado: {
                  totales: {},
                  dias: Array(7)
                    .fill({})
                    .map((_, i) => ({
                      fecha: moment(this.query.periodo.start)
                        .add(i, "days")
                        .format("YYYY-MM-DD"),
                    })),
                  _dias: [
                    { fecha: "2023-07-27" },
                    { fecha: "2023-07-28" },
                    { fecha: "2023-07-29" },
                    { fecha: "2023-07-30" },
                    { fecha: "2023-07-31" },
                    { fecha: "2023-08-01" },
                    { fecha: "2023-08-02" },
                  ],
                },
              },
            };
            itm.payload.encabezado.periodo_inicial = moment(
              this.query.periodo.start
            ).format("YYYY-MM-DD");
            itm.payload.encabezado.periodo_final = moment(
              this.query.periodo.end
            ).format("YYYY-MM-DD");
            itm.payload.encabezado.empresa_id = this.query.empresa.value;
            itm.payload.encabezado.trabajador_id = m.id;
            itm.payload.encabezado._relaciones = {
              trabajador: m,
            };
            return itm;
          });
          this.items = trabajadoresSlice.map((m) => {
            const foud = [...documentos.data, ...calculos].find(
              (f) => f.payload.encabezado.trabajador_id === m.id
            );
            return foud;
          });

          // this.page = documentos?.paginate?.current_page;
          console.log(this.items);
          debugger;
        })
        .catch((rej) => console.log(rej.message))
        .finally(() => {
          this.isLoading = false;
          this.isLoadingInfo = false;
        });
    },
  },
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.footer-table {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}

.dropdown-menu {
  min-width: 14rem;
}

.advance-filter .multiselect__spinner {
  height: 30px;
}

.advance-filter .multiselect__placeholder {
  margin-bottom: 0px;
}

.advance-filter .multiselect__select {
  height: 34px;
}

.advance-filter .multiselect__tags {
  max-height: 35px;
  overflow: auto;
  min-height: unset;
  padding: 5px 40px 5px 5px;
}

.advance-filter .multiselect__content-wrapper {
  width: 100%;
}

.advance-filter .vs__dropdown-toggle {
  height: 35px;
}
</style>

<style scoped>
.line {
  width: 100%;
  color: #321fdb;
  /* old IE */
  background-color: #321fdb;
  /* Modern Browsers */
}

.z-custom {
  z-index: 1;
}

.z-custom-2 {
  z-index: 4;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.catalogo-text {
  font-size: 1.2rem !important;
}

.custom-width-btn {
  width: 40%;
}

.custom-heigth-btn {
  width: 100%;
}

.custom-font-size {
  font-size: 1rem;
}

@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
